import React, { useState } from "react";

const BdosViewer = ({ materialId }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  // 🌟 1. 获取环境变量（动态识别本地还是线上）
  const backendUrl = process.env.REACT_APP_BASE_URL || "";

  // 🌟 2. 直接拼接出完整的后端请求地址
  const bdosUrl = `${backendUrl}/api/get_bdos_url/${materialId}`;

  return (
    <div style={{ position: "relative", width: "100%", height: "600px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>

      {/* 🌟 这是一个好看的居中动画加载圈，缓解加载大文件时的白屏焦虑 */}
      {!iframeLoaded && (
        <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          display: "flex", flexDirection: "column", alignItems: "center", color: "#64748b"
        }}>
          <div className="spinner" style={{
            width: "40px", height: "40px", border: "4px solid #e2e8f0",
            borderTop: "4px solid #3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite"
          }} />
          <p style={{ marginTop: "12px", fontWeight: "500" }}>Loading High-Res BDOS Plot, this will take a few minutes...</p>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      {/* 🌟 3. iframe 直接读取同源地址，浏览器再也不会把它当成追踪器拦截了！ */}
      <iframe
        src={bdosUrl}
        width="100%"
        height="100%"
        style={{ border: "none", display: iframeLoaded ? "block" : "none", borderRadius: "8px" }}
        title="BDOS Plot"
        onLoad={() => setIframeLoaded(true)}
      />
    </div>
  );
};

export default BdosViewer;